import { render, staticRenderFns } from "./study_search.vue?vue&type=template&id=9d28e158&scoped=true&"
import script from "./study_search.vue?vue&type=script&lang=js&"
export * from "./study_search.vue?vue&type=script&lang=js&"
import style0 from "./study_search.vue?vue&type=style&index=0&id=9d28e158&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d28e158",
  null
  
)

export default component.exports